export default __webpack_public_path__ + "static/media/5.a269a67f.jpeg";